
<template>
  <div class="tinymce-editor">
    <editor v-model="myValue" :init="init" :disabled="disabled" ></editor>
  </div>
</template>
<script>
import tinymce from "tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver";
import "tinymce/icons/default/icons";

import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/preview";
import "tinymce/plugins/code";
import "tinymce/plugins/link";
import "tinymce/plugins/advlist";
import "tinymce/plugins/codesample";
import "tinymce/plugins/hr";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/autolink";
import "tinymce/plugins/directionality";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/template";
import "tinymce/plugins/charmap";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/autosave";
import "tinymce/plugins/autoresize";

const oss = require('ali-oss');


export default {
    components: {
        Editor
    },

    props: {
        height:{
            type:Number,
            default:document.body.offsetHeight - 320
        },
        value: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
        plugins: {
            type: [String, Array],
            default:
        "preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr nonbreaking insertdatetime advlist lists wordcount imagetools textpattern autosave autoresize"
        },
        // 默认工具栏 这里写的比较全，基本上是全部了
        toolbar: {
            type: [String, Array],
            default:
        "code undo redo restoredraft template | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link codesample | alignleft aligncenter alignright alignjustify outdent indent formatpainter | \
    styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
    table image media charmap hr pagebreak insertdatetime | fullscreen preview"
        }

    },
    data() {
        return {
            init: {
                language_url: "/ui/tinymce/langs/zh_CN.js",
                language: "zh_CN",
                skin_url: "/ui/tinymce/skins/ui/oxide",
                // skin_url: '/tinymce/skins/ui/oxide-dark',//暗色系
                toolbar_mode: "wrap",
                height: this.height,
                min_height: 300,
                max_height: 800,
                plugins: this.plugins,
                toolbar: this.toolbar,
                content_style: "p {margin: 5px 0;}",
                fontsize_formats: "12px 14px 16px 18px 24px 36px 48px 56px 72px",
                font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;",

                branding: false,
                menubar: false,
                theme: "silver",
                //上传图片回调
                images_upload_handler:(blobInfo, success) => {
                    let result = this.D.syncSelect({
                        type: 'servicekey/importConfig',
                        params: {

                        }
                    })
                    if (result.success !== '1') {
                        // that.message.error(result['errorMsg']);
                        return false;
                    }
                    const data = result.data;
                    const {
                        dir,
                        accessid,
                        bucket,
                    } = data;
                    const client = oss({
                        region: 'oss-cn-shanghai',
                        accessKeyId: accessid,
                        accessKeySecret: 'FSE4RDsRiO4nnBhO0yY8TNBHmDis3X',
                        bucket: bucket,
                        secure:true,
                    });
                    var filename = dir + this.getUniqueCode() + this.getSuffix(blobInfo.filename());
                    client.put(filename, blobInfo.blob()).then(function (result) {
                        if(result.res.requestUrls) {
                            success(result.res.requestUrls[0]);
                        }
                    }).catch(function (err) {
                        console.log(err);
                    });
                },
                templates: this.getTemplete(),
            },
            myValue: this.value
        };
    },
    mounted() {
        tinymce.init({});
    },
    methods: {
        getTemplete(){
            //在线获取模板
            let that = this
            let params = {
                menucode:'templete',
                urlparams:false
            };
            let result = [];
            try {
                that.$store.dispatch({
                    type: "open/syncselectdoclist",
                    params:params
                }).then((res)=>{
                    res.data.forEach(element => {
                        result.push({
                            title:element.title,
                            description:element.desc,
                            content:element.body
                        })
                    });
                
                }).catch(() => {
                    return result
                });
            } catch (error) {
                return result
            }
            
            return result
        },
        getUniqueCode(){
            const s = [];
            const hexDigits = "0123456789abcdef";
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = "-";
            return s.join("");
        },
        getSuffix(filename){
            const pos = filename.lastIndexOf('.');
            let suffix = '';
            if (pos !== -1) {
                suffix = filename.substring(pos)
            }
            return suffix;
        },
    },
    watch: {
        value(newValue) {
            this.myValue = newValue;
        },
        myValue(newValue) {
            this.$emit("input", newValue);
        }
    }
};
</script>
